import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lang" }

import { useI18n } from 'vue-i18n'
import { DownOutlined } from '@ant-design/icons-vue';
import { computed, watch, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'Language_switch',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const { locale } = useI18n()
const lang = ref(localStorage.getItem('lang') || 'zh-CN')

// 切换语言函数
const changeLanguage = (lang: any) => {
    locale.value = lang.key
    lang.value = lang.key
    localStorage.setItem('lang', lang.key) // 持久化保存
    router.replace({ query: { ...route.query, zone: lang.key } })
}


return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_dropdown, null, {
      overlay: _withCtx(() => [
        _createVNode(_component_a_menu, { onClick: changeLanguage }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "zh-CN" }, {
              default: _withCtx(() => [
                _createTextVNode(" 简体中文 ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "en-US" }, {
              default: _withCtx(() => [
                _createTextVNode(" English ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("a", {
          class: "ant-dropdown-link",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createTextVNode(_toDisplayString(_unref(locale) == 'zh-CN' ? '简体中文' : 'English') + " ", 1),
          _createVNode(_unref(DownOutlined))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})